export const NR1_LINKS_ADMIN_PAGE = () => "/operacoes/nr1-links";
export const NR1_DASHBOARD_PAGE = () => "/operacoes/nr1-dashboard";
export const NR1_PUBLIC_FORM_PAGE = (token = ":token") => `/nr1/${token}`;
